import { IconButton, Skeleton, styled, Typography, useTheme, Box } from "@mui/material";
import { memo, useEffect, useState } from "react";
import { apiGetDashboardFinancials } from "../../api/dashboardApi";
import ContinueIcon from "../../assets/icons/ContinueIcon";
import CardCarousel from "../Carousel/card-carousel";
import { BoxUpper } from "../Shared/BoxUpper";
import { BoxBodyContainer, RawBox } from "../Shared/Dashboard/styled";
import { useAppDispatch, useAppSelector } from "store/store";
import RefreshIcon from "assets/icons/RefreshIcon";

const StyledBoxBodyContainer = styled(BoxBodyContainer)({
  height: "100px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  position: "relative",
  overflow: "hidden",
  justifyContent: "center",
});

const BottomSection = styled("div")(({ theme }) => ({
  height: "70px",
  backgroundColor: "#DEE6F1B0",
  position: "absolute",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  bottom: 0,
  zIndex: 2,
  padding: "15px 40px",
  borderRadius: `0 0 ${theme.shape.borderRadius} ${theme.shape.borderRadius}`,
}));
const RightSection = styled("div")({
  display: "flex",
  justifyContent: "space-between",
});

const Banking = ({ title }: { title?: string }) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const token = useAppSelector((x) => x.businessReducer.business?.token);
  const financials = (useAppSelector((x) => x.dashboardReducer.financials) as Finance[]) || [];
  const [slide, setSlide] = useState(0);
  const onClick = () => {
    dispatch(apiGetDashboardFinancials(token, changeLoading));

  }
  // useEffect(() => {
  //   if (token) {
  //     dispatch(apiGetDashboardFinancials(token));
  //   }
  // }, [token]);

  useEffect(() => {
    financials.length > 0 && setSlide(financials.length - 1);
  }, [financials]);

  const changeSlide = (index: number) => {
    setSlide(index);
  };
  const [isLoading, setLoading] = useState(false)
  const changeLoading = () => {
    setLoading(state => !state)
  }
  return (
    <RawBox>
      <BoxUpper title={title} />
      <StyledBoxBodyContainer>
        {financials && financials.length > 0 && !!financials[slide] ? (
          <>
          <div style={{ padding: "70px" }}></div>
            <CardCarousel setActiveSlide={changeSlide} arrayData={financials} />
            <BottomSection>
              <RightSection>
                <Typography style={{ direction: "ltr" }}>
                  {Intl.NumberFormat().format(financials[slide]?.balance)}
                </Typography>
                <Typography color={theme.palette.text.secondary}>
                  &nbsp;{financials[slide].Currency.fa_title}
                </Typography>
              </RightSection>
              <IconButton
                onClick={() =>
                  window.open(
                    `/reports/${financials[slide]?.type}Transactions?${financials[slide]?.type}Id=${financials[slide].id}`
                  )
                }
              >
                <ContinueIcon />
              </IconButton>
            </BottomSection>
          </>
        ) :
          (<Box
            onClick={() => {
              onClick()
            }}
            sx={{
              position: 'relative',
              width: '100%', // Set your desired width
              height: 320, // Set your desired height
              display: 'flex',
              justifyContent: 'center',
              cursor: 'pointer',
              alignItems: 'center',
              // border: '1px solid #ccc', // Optional: for visual reference
            }}
          >
            <Skeleton variant="rectangular" width={"100%"} height={"100%"} />
            <Typography
              variant="h6"
              sx={{
                position: 'absolute',
                color: '#747575', // Change color based on your skeleton background
              }}
            >
              نمایش اطلاعات
            </Typography>
            <div className={`absolute bottom-[35%] ${isLoading ? "animate-spin" : ""}`}>
                  <RefreshIcon scale={0.8} />
                </div>

          </Box>)
        }
      </StyledBoxBodyContainer>
    </RawBox>
  );
};

export default memo(Banking);
